import {Map, fromJS} from "immutable";

import {
    REGISTER_MOVEMENT_REQUEST,
    REGISTER_MOVEMENT_SUCCESS,
    REGISTER_MOVEMENT_ERROR,
    CLEAN_MOVEMENT,
    UPDATE_MOVEMENT_REQUEST,
    UPDATE_MOVEMENT_SUCCESS,
    UPDATE_MOVEMENT_ERROR
} from '../actions/movement';

const movement = (state = Map({
    payload: Map({}),
    isFetching: false,
    error: false
}), action) => {
    let newState;
    switch (action.type) {
        // Requests
        case REGISTER_MOVEMENT_REQUEST:
        case UPDATE_MOVEMENT_REQUEST:
            newState = state.merge({
                isFetching: action.isFetching,
                error: action.error
            });
            return newState;

        // Success
        case REGISTER_MOVEMENT_SUCCESS:
        case CLEAN_MOVEMENT:
            newState = state.merge({
                isFetching: action.isFetching,
                error: action.error,
                created: action.created,
                payload: fromJS(action.payload)
            });
            return newState;

        case UPDATE_MOVEMENT_SUCCESS:
            return state;

        // Errors
        case REGISTER_MOVEMENT_ERROR:
        case UPDATE_MOVEMENT_ERROR:
        default:
            return state;
    }
};

export default movement;



// WEBPACK FOOTER //
// ./src/reducers/movement.js